module.exports = __webpack_public_path__ + "img/Picture19.ee5f3062.jpg";